import { getCarPrizeList, saveClueInfo } from '@this/services/clue';
import { Toast } from 'vant';
import sample from 'lodash/sample';
import localStorage from '@/utils/localStorage';
const state = {
  showAskPriceDialog: false,
  showSuccessDialog: false,
  showPrice:false,
  normalSeriesIds: [3225, 3996, 2734, 631, 4580, 4550, 22813, 424],
  carPrizeList: [],
  askPriceInfo: {},
  askedPriceIds: [],
  serialInfo:{},
  higePrice:'',
  lowPrice:'',
};
const mutations = {
  setAskPriceInfo(state, obj) {
    state.askPriceInfo = obj;
  },
  setShowPrice(state, bool) {
    state.showPrice = bool;
  },
  setShowAskPriceDialog(state, bool) {
    state.showAskPriceDialog = bool;
  },
  setShowSuccessDialog(state, bool) {
    state.showSuccessDialog = bool;
  },
  setCarPrizeList(state, list) {
    state.carPrizeList = list;
  },
  setAskedPriceIds(state, list) {
    state.askedPriceIds = list;
  },
  setSerialInfo(state,obj){
   state.serialInfo = obj;
  },
  setHigePrice(state,str){
    state.higePrice = str;
   },
   setLowPrice(state,str){
    state.lowPrice = str;
   },
};
const actions = {
  changeShowAskPriceDialog({ commit, state }, bool) {
    const showAskPriceDialog = bool ?? !state.showAskPriceDialog;
    commit('setShowAskPriceDialog', showAskPriceDialog);
  },
  changeShowSuccessDialog({ commit, state }, bool) {
    const showSuccessDialog = bool ?? !state.showSuccessDialog;
    commit('setShowSuccessDialog', showSuccessDialog);
  },
  getAskedPriceIds({ commit }) {
    const askPrizeIds = localStorage.get('askPrizeIds') || [];
    commit('setAskedPriceIds', askPrizeIds);
  },
  selectCarPrize({ dispatch, commit }, item) {
    commit('setAskPriceInfo', item);
    dispatch('changeShowAskPriceDialog');
  },
  selectMorePrice({ state, dispatch, commit }, item) {
    commit('setAskPriceInfo', {
      ...state.askPriceInfo,
      name: item.name,
      id: item.pcauto_id,
    });
    if (state.askedPriceIds.indexOf(item.pcauto_id) > -1) {
      Toast('该车系已经询过价');
    } else {
      dispatch('changeShowAskPriceDialog');
    }
    dispatch('brand/changeShowMoreBrand', false, { root: true });
    dispatch('brand/changeShowMoreSeries', false, { root: true });
  },
  getCarPrizeList({ state, commit }, id) {
    const serial_id = id || sample(state.normalSeriesIds);
    return getCarPrizeList({ sgid: serial_id, type: 1, num: 6 }).then((res) => {
      commit('setSerialInfo',sample(res.data.serialGroups));
      commit('setHigePrice',state.serialInfo.price.split('-')[1]);
      commit('setLowPrice',state.serialInfo.price.split('-')[0]);
      commit('setCarPrizeList', res.data.serialGroups);
    });
  },
  async clickBrandGetAskPriceList({ commit, dispatch }, brand) {
    commit('setAskPriceInfo', { brandName: brand.name, brandId: brand.pcauto_id });
    await dispatch('brand/getSeriesList', brand.pcauto_id, { root: true });
    dispatch('brand/changeShowMoreSeries', true, { root: true });
  },
  async clickAskPrice({ state, rootState, dispatch, commit }) {
    const { brandName: brand_name, brandId: brand_id, name: serial_name, id: serial_id, showPrice } = state.askPriceInfo;
    const { province, city, position } = rootState.city.location;
    const { mid } = rootState.user;
    if (!city) return;
    const data = {
      brand_name,
      brand_id,
      serial_name,
      serial_id,
      location_province: province,
      location_city: city,
      location_amap: position,
      call_name: rootState.user.userInfo.name,
      mid,
    };
    await saveClueInfo(data);
    dispatch('changeShowAskPriceDialog', false);
    dispatch('changeShowSuccessDialog', true);
    if(showPrice){
      commit('setShowPrice',true)
    }
    const askPrizeIds = localStorage.get('askPrizeIds') || [];
    commit('setAskedPriceIds', [...askPrizeIds, serial_id]);
    localStorage.set('askPrizeIds', state.askedPriceIds);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
